import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import { TreatmentFeedbackConverter } from '../../../api/models/converter/treatment-feedback.converter';
import { TreatmentFeedbackModel } from '../../../api/models/treatment-feedback.model';
import { TreatmentFeedbackDataService } from './treatment-feedback.data.service';

@Injectable()
export class TreatmentFeedbackDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<TreatmentFeedbackModel, TreatmentFeedbackConverter> {
    constructor(dataService: TreatmentFeedbackDataService, converter: TreatmentFeedbackConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): TreatmentFeedbackModel {
        return new TreatmentFeedbackModel();
    }
}
